import React from "react";
import { Responsive, WidthProvider, Layouts, Layout } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import type { DashboardWidget } from "../../../types/dashboard/dashboard.types";

import WidgetShell from "../widget/WidgetShell";
import WidgetRenderer from "../widget/WidgetRenderer";

const ResponsiveGridLayout = WidthProvider(Responsive);

type Props = {
    widgets: DashboardWidget[];
    layouts: Layouts;
    isEditMode: boolean; // ✅
    onLayoutChange: (current: Layout[], all: Layouts) => void;
    onBreakpointChange: (bp: string) => void;
    onRequestDelete: (widget: DashboardWidget) => void;
};


export default function DashboardGrid({
    widgets,
    layouts,
    onLayoutChange,
    onBreakpointChange,
    onRequestDelete,
    isEditMode

}: Props) {
    return (
        <ResponsiveGridLayout
            className="layout"
            layouts={layouts}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
            rowHeight={30}
            onLayoutChange={onLayoutChange}
            onBreakpointChange={onBreakpointChange}
            margin={[10, 10]}
            compactType="vertical"
            preventCollision={true}
            isResizable={isEditMode}
            isDraggable={isEditMode}
            draggableHandle={isEditMode ? ".widget-header" : undefined}


        >
            {widgets?.length ? (
                widgets.map((widget) => (
                    <div key={widget.id}>
                        <WidgetShell
                            widget={widget}
                            isEditMode={isEditMode}      
                            onRequestDelete={onRequestDelete}
                        >
                            <WidgetRenderer widget={widget} />
                        </WidgetShell>

                    </div>
                ))
            ) : (
                <div>Pas de widgets disponibles.</div>
            )}
        </ResponsiveGridLayout>
    );
}
